module.exports = __webpack_public_path__ + "static/media/menu-icon-discovery.735ee131.png";